/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

import { Base } from "..";
import createLogger from "../../utils/logger.util";

const logger = createLogger({ name: "CarDescription" });

class CarDescription extends Base {
	public static async addRoute(
		parameters: CarDescription.AddRouteParameters,
	) {
		try {
			const res = await this.request((prpc) =>
				prpc.theirsModel.carDescription.addRoute(parameters),
			);

			logger.info("[CarDescription] addRoute", { parameters, res });
		} catch (error) {
			logger.error("[CarDescription] error addRoute", error);
		}
	}
}

namespace CarDescription {
	export interface AddRouteParameters {
		carBaseTypeName: string;
		carBrandName: string;
		carModelName: string;
		carBodyTypeName: string;
		carClassIds?: number[];
	}
}

export default CarDescription;
